// Mirrors --mg-z-xoe-popup (global.css): above the floating Xoe frame at --mg-z-xoe (1150).
export const XOE_POPUP_Z_INDEX = 1160;

// The floating frame's height; mirrored by .mg-xoe-float-slot in xoe.css and read by XoeWidget's placement maths.
export const XOE_PANEL_HEIGHT = 540;
